"use strict";
// Builders
document.addEventListener('DOMContentLoaded', () => {
    var _a, _b, _c;
    let currentPath = window.location.href;
    let urlPerSection = currentPath.split('/');
    if (urlPerSection[3] == "constructoras" || urlPerSection[3].includes("constructoras?search")) {
        (_a = document.getElementById("title-constructoras")) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
    }
    if (urlPerSection[3] == "") {
        (_b = document.getElementById("constructoras-destacadas-slider")) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
    }
    // tabs constructoras
    let optionTabBuilder = document.getElementById('id-city') ? document.getElementById('id-city').innerHTML : '';
    if (document.getElementById('tab-builder-' + optionTabBuilder)) {
        (_c = document.getElementById('tab-builder-' + optionTabBuilder)) === null || _c === void 0 ? void 0 : _c.classList.add('active');
    }
});
